import { Injectable, Injector } from '@angular/core';

import { Observable } from 'rxjs';
import { HttpService, cacheResult } from 'projects/core/src/public-api';
import { AppStateStore } from 'projects/desktop/src/app/data/app-state.store';
import { AppStateQuery } from 'projects/desktop/src/app/data/app-state.query';
import { FileService } from 'projects/core/src/lib/misc/data/file/file.service';
import { EntityEventEmitter } from 'projects/core/src/lib/core/data/entities/entity-event-emitters';
import { Cabinet } from './cabinet';
import { WsService } from '../../data/ws.service';
import { environment } from 'projects/mobile/src/environments/environment';
import { ProjectStatus } from '../../project-misc/data/project/statuses/project-status';
import { Memoize } from 'projects/core/src/lib/core/utils/decorators/memoize-decorator';
import { ActivityType } from '../../project-misc/data/project/activity/activity-type';
import {ShortObject} from '../../project-misc/data/project/short-json-object';
import {Any} from 'json2typescript';

@Injectable({
  providedIn: 'root',
})
export class CabinetsService extends HttpService {
  // cabinetEmitter = new EntityEventEmitter<Cabinet>();

  constructor(
    protected injector: Injector,
    protected appStateStore: AppStateStore,
    protected appStateQuery: AppStateQuery,
    protected fileService: FileService,
    protected wsService: WsService
  ) {
    super(injector);
  }

  getCabinets(projectId: number): Observable<Cabinet[]> {
    return this.getData(`/cabinets/list/for-project/${projectId}`, Cabinet);
  }

  createCabinets(projectId: number, cabinet: Cabinet): Observable<Cabinet> {
    return this.postData(`/cabinets/list/for-project/${projectId}/add`, cabinet, Cabinet);
  }

  deleteCabinet(cabinetId: number): Observable<Cabinet> {
    return this.deleteData(`/cabinets/${cabinetId}`, Cabinet);
  }

  @Memoize()
  getCabinetStatuses(): Observable<ProjectStatus[]> {
    return this
    .getData(`/dictionary-word/list/for-type/CV_CABINET_STATUS`, ProjectStatus)
    .pipe(
      cacheResult(environment.dataDefaultCacheTime)
    );
  }

  scanCabinet(cabinetId: number, booleanString: string): Observable<Cabinet> {
    return this.putData(`/cabinets/${cabinetId}/status?value=true&status=${booleanString}`, {}, Cabinet)
  }


  saveCabinet(cabinet: Cabinet): Observable<Cabinet> {
    return this.putData('/cabinets', cabinet, Cabinet)
  }

  printLabels(projectId: number): Observable<Cabinet[]> {
    return this.postData(`/project/${projectId}/cabinets/labels/print`, {}, Cabinet);
  }

  printSelectedLabels(projectId: number, cabIds: string): Observable<Cabinet[]> {
    return this.postData(`/project/${projectId}/cabinets/labels/print?ids=${cabIds}`, {}, Cabinet);
  }

  createPunchItems(projectId: number, cabinetNames: string[]): Observable<any> {
    return this.postData(`/project/${projectId}/create-punch-items-from-cabinets`, { cabinetNames }, Any)
  }

  getIncompleteQCCabinets(projectId: number): Observable<Cabinet[]> {
    return this.getData(`/cv/cabinets/incomplete-qc-list/for-project/${projectId}`, Cabinet)
  }

  addIgnoredCabinet(cabinetName: any): Observable<ShortObject> {
    return this.postData('/ignored-cabinets/add', cabinetName, ShortObject);
  }

  getIgnoredCabinets(): Observable<ShortObject[]> {
    return this.getData('/ignored-cabinets/list', ShortObject);
  }

  removeIgnoredCabinet(cabinetId: number): Observable<number> {
    return this.deleteData(`/ignored-cabinets/${cabinetId}`, Any);
  }

}
